import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const mobileCategoryThumbs = [
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20sneakers%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-01&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20hoodie%20sweater%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-02&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20t-shirt%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-03&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20jacket%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-04&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20pants%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-05&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20baseball%20cap%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-06&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20clothing%20set%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-07&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20cotton%20underwear%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-08&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20sports%20jersey%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-09&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20sunglasses%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-10&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20backpack%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-11&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20leather%20belt%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-12&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20perfume%20bottle%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-13&orientation=squarish',
  'https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20thumbnail%20of%20lifestyle%20accessories%20on%20warm%20cream%20background%20soft%20natural%20light%20editorial%20style&width=80&height=80&seq=mob-thumb-14&orientation=squarish',
];

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsDropdownOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.getElementById('navbar');
      if (navbar) {
        if (window.scrollY > 10) {
          navbar.classList.add('bg-background-50/95', 'backdrop-blur-md');
          navbar.classList.remove('bg-transparent');
        } else {
          navbar.classList.add('bg-transparent');
          navbar.classList.remove('bg-background-50/95', 'backdrop-blur-md');
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav id="navbar" className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-transparent">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <div className="flex items-center gap-1">
            <Link to="/" className="flex items-center gap-2 no-underline">
              <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-file-list-3-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading font-bold text-lg md:text-xl text-foreground-900 whitespace-nowrap">
                Vigorbuy Guide
              </span>
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              Home
            </Link>

            <div ref={dropdownRef} className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <span>Categories</span>
                <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}></i>
              </button>
              {isDropdownOpen && (
                <div className="absolute top-full left-0 mt-1 w-64 bg-background-50 rounded-xl border border-background-200/70 overflow-hidden z-50 shadow-sm">
                  <div className="p-2 max-h-[420px] overflow-y-auto">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        <div className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100">
                          <i className={`${cat.icon} text-foreground-500 text-sm`}></i>
                        </div>
                        {cat.name}
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>

            <Link
              to="/shopping-guide"
              className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              Shopping Guide
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              Vigorbuy Spreadsheet
            </a>

            <Link
              to="/article/vigorbuy-spreadsheet-complete-guide"
              className="px-4 py-2 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              Guide
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="ml-2 px-5 py-2.5 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 transition-colors cursor-pointer"
          >
            <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 max-h-[80vh] overflow-y-auto">
          <div className="px-4 py-3 space-y-1">
            <Link
              to="/"
              className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-semibold text-foreground-900 hover:bg-background-100 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-primary-100">
                <i className="ri-home-4-line text-primary-600 text-sm"></i>
              </div>
              Home
            </Link>

            <div className="border-t border-background-200/70 my-2"></div>
            <p className="px-3 py-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Product Categories</p>

            {categories.map((cat, idx) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="w-10 h-10 flex-shrink-0 rounded-lg overflow-hidden bg-background-100">
                  <img
                    src={mobileCategoryThumbs[idx]}
                    alt={cat.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <span className="text-sm font-medium text-foreground-900">{cat.name}</span>
                  <span className="block text-xs text-foreground-400">Browse products</span>
                </div>
              </a>
            ))}

            <div className="border-t border-background-200/70 my-2"></div>
            <p className="px-3 py-2 text-xs font-semibold text-foreground-400 uppercase tracking-wider">Quick Links</p>

            <Link
              to="/shopping-guide"
              className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-accent-100">
                <i className="ri-book-open-line text-accent-600 text-sm"></i>
              </div>
              Shopping Guide
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100">
                <i className="ri-external-link-line text-foreground-500 text-sm"></i>
              </div>
              Vigorbuy Spreadsheet
            </a>

            <Link
              to="/article/vigorbuy-spreadsheet-complete-guide"
              className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100">
                <i className="ri-guide-line text-foreground-500 text-sm"></i>
              </div>
              Complete Guide
            </Link>

            <Link
              to="/security"
              className="flex items-center gap-3 px-3 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <div className="w-7 h-7 flex items-center justify-center rounded-md bg-background-100">
                <i className="ri-shield-check-line text-foreground-500 text-sm"></i>
              </div>
              Security &amp; Privacy
            </Link>

            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors mt-2"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              Buy It Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}